export const getCellDeletionButtonDecoratorStyle = () => ({
  cellDeletionButtonDecorator: {
    position: 'absolute',
    bottom: 8,
    right: 10,
  },
});

export const getFluentUIStyles = (components, { palette = {} } = {}) => ({
  deleteButtonStyles: {
    root: {
      backgroundColor: palette.themeLighter,
      opacity: 0.7,
      zIndex: 2,
      padding: 0,
      height: 24,
      width: 24,
    },
    rootHovered: {
      opacity: 0.9,
    },
    rootPressed: {
      opacity: 1,
    },
    icon: {
      margin: 0,
    },
  },
});
